// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1iqRA","modalFooterButton":"ModalNotes_modalFooterButton__31JVW"};